"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipNameReadingFileState = void 0;
var ZipNameReadingFileState;
(function (ZipNameReadingFileState) {
    ZipNameReadingFileState["InQueueNameReadingZip"] = "inQueueNameReadingZip";
    ZipNameReadingFileState["GeneratingNameReadingZip"] = "generatingNameReadingZip";
    ZipNameReadingFileState["FailedNameReadingZip"] = "failedNameReadingZip";
    ZipNameReadingFileState["DeletingNameReadingZip"] = "deletingNameReadingZip";
    ZipNameReadingFileState["CompletedNameReadingZip"] = "completedNameReadingZip";
})(ZipNameReadingFileState = exports.ZipNameReadingFileState || (exports.ZipNameReadingFileState = {}));
//# sourceMappingURL=zip-name-reading-status.js.map